import { render, staticRenderFns } from "./phenotype_legend.vue?vue&type=template&id=9ba79c94&scoped=true"
import script from "./phenotype_legend.vue?vue&type=script&lang=js"
export * from "./phenotype_legend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba79c94",
  null
  
)

export default component.exports